import { Box, Button, Select, Stack, TextField, Typography } from "@mui/material";
import ButtonBar from "../../components/button-bar/ButtonBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthenticationContext } from "../../components/authentication/AuthenticationContext";
import { Playlist } from "../../types/Playlist";
import { postPlaylist } from "../../components/apis/music-api";
import { PlaylistType } from "../../types/PlaylistType";

const CreatePlaylist = () => {
    const navigate = useNavigate();
    const { getAccessToken } = useContext(AuthenticationContext);
    const [ playlist, setPlaylist ] = useState<Playlist>({
        id: '',
        name: '',
        duration: 0,
        playlistType: PlaylistType.Unknown,
        playlistItems: [],
    });

    const save = async () => {
        await postPlaylist(getAccessToken(), playlist);
        navigate(`/playlists`);
    }

    const handleSave = () => {
        save();
    }

    return (
        <>
            <ButtonBar
                leftButtons={[
                    <Button component={Link} variant="contained" size="small" to={`/genres`}>
                        <FontAwesomeIcon fontSize="small" color="primary" icon={faBan} className="icon"/>
                        Cancel
                    </Button>
                ]}
                rightButtons={[
                    <Button variant="contained" size="small" onClick={handleSave}>
                        <FontAwesomeIcon fontSize="small" color="primary" icon={faPenToSquare} className="icon"/>
                        Save Changes
                    </Button>
                ]}
            />
            <Stack direction="row" spacing={2} sx={{ justifyContent: 'center' }}>
                <Box sx={{ width: '628px' }}>
                    <Box sx={{ mb: '20px' }}><Typography variant="h6">Create A Playlist</Typography></Box>
                    <Stack spacing={3}>
                        <Box>
                            <Select
                                native
                                id="playlist-type"
                                sx={{ width: '420px' }}
                                size="small"
                                label="Playlist Type"
                                onChange={(e) => setPlaylist({ ...playlist, playlistType: e.target.value as PlaylistType })}>
                                <option value={PlaylistType.Unknown}>Unknown</option>
                                <option value={PlaylistType.Artists}>Artist</option>
                                <option value={PlaylistType.Albums}>Album</option>
                                <option value={PlaylistType.Tracks}>Track</option>
                            </Select>
                        </Box>
                        <Box>
                            <TextField 
                                id="genre-name"
                                sx={{ width: '420px' }}
                                size="small"
                                label="Name"
                                InputLabelProps={{ shrink: true }}
                                variant="outlined" 
                                value={playlist?.name}
                                onChange={(e) => setPlaylist({ ...playlist, name: e.target.value })}
                            />
                        </Box>
                    </Stack>
                </Box>
            </Stack>
        </>
    );
}

export default CreatePlaylist;